var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M13.8363 2.17969C20.1527 2.17969 25.2387 5.78906 26.7426 11.0391H34.4535V0.101562H42.2738V27.1172H34.4535V17.2188H26.7973C25.3207 22.6328 20.1801 26.2969 13.8363 26.2969C6.0707 26.2969 0.328512 21.2109 0.3832 14.1562C0.328512 7.26562 6.0707 2.17969 13.8363 2.17969ZM13.8363 8.6875C10.2816 8.6875 7.8207 10.7109 7.8207 14.1562C7.8207 17.6562 10.2816 19.6797 13.8363 19.6797C17.2269 19.6797 19.6879 17.6562 19.6879 14.1562C19.6879 10.7109 17.2269 8.6875 13.8363 8.6875ZM16.1879 29.1953V33.5156H34.4535V29.1953H42.2738V49.7578H8.47695V29.1953H16.1879ZM16.1879 43.4141H34.4535V39.5312H16.1879V43.4141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText02);
export default __webpack_public_path__ + "static/media/text02.4c555bd373e1846fcde33ff797fa7fda.svg";
export { ForwardRef as ReactComponent };